import { useCallback, useEffect, useState } from "react";
import { posAPI, shopSession } from "../../services/api";
import { tr } from "../../i18n";
import { toPackItem } from "../utils/packs";

const EMPTY_STORE = { name: "Vape Store", currency: "TND", low_stock_threshold: 10 };

/**
 * Loads the sellable catalog and the store display settings in one call.
 * Stock changes after every sale, so `refresh` is called once a sale lands.
 */
export const useCatalog = () => {
  const [products, setProducts] = useState([]);
  const [groups, setGroups] = useState([]);
  const [store, setStore] = useState(EMPTY_STORE);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async ({ silent = false } = {}) => {
    if (!silent) setLoading(true);
    try {
      const response = await posAPI.getCatalog();
      // Packs sell like products, so they join the same list: one grid, one
      // search, one ticket
      setProducts([
        ...(response.data.products || []),
        ...(response.data.packs || []).map(toPackItem),
      ]);
      setGroups(response.data.groups || []);
      setStore(response.data.store || EMPTY_STORE);
      // Which shop this till is, so its queued sales and held tickets stay its own
      shopSession.record(response.data.store?.id);
      setError("");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data?.error ||
          tr("pos.catalogError")
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { products, groups, store, loading, error, refresh: load };
};
